"use client"

import React, { useRef, useEffect, useState } from 'react'
import ChevronDownIcon from "@/components/icons/ChevronDownIcon";
import { cn, initArray } from "@/utils/utils";


export default function ProductSelectQuantity({ onChangeQuantity, quantity, max , maxValid }: { onChangeQuantity: (quantity: number) => void, quantity: number, max: number , maxValid: number }) {

  const [isOpenSelectQuantity, setIsOpenSelectQuantity] = useState(false);
  const selectQuantityRef = useRef<HTMLButtonElement>(null)
  const MAX_QUANTITY = max || 10


  function handleOnSelectQuantity(e: React.MouseEvent<HTMLLIElement, MouseEvent>, quantity: number) {
    e.stopPropagation()
    // setQuantity(quantity)
    onChangeQuantity(quantity)
    setIsOpenSelectQuantity(false)
  }
  useEffect(() => {

    function handleClickOutside(event: any) {
      if (selectQuantityRef.current && !selectQuantityRef.current.contains(event.target)) {
        setIsOpenSelectQuantity(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectQuantityRef]);
  return (
    <button ref={selectQuantityRef} onClick={() => setIsOpenSelectQuantity(pre => !pre)} className=" w-[55px]  relative flex-shrink h-full border-r border-red-500 flex items-center justify-center gap-2 ">{quantity}
      {isOpenSelectQuantity ? <ChevronDownIcon /> : <ChevronDownIcon className=' rotate-180' />}
      {isOpenSelectQuantity && <div className=" absolute bottom-full left-0 right-0 bg-white shadow-lg border border-gray-300">
        <ul className=' flex flex-col-reverse max-h-[400px] overflow-auto'>
          {initArray(MAX_QUANTITY, []).map((_, index) => {
            if (index + 1 === quantity) {
              return null
            }
            return (<li key={index} className={
              cn(" py-2 px-3 flex justify-center items-center border border-gray-300",{
                " opacity-50 border-gray-200" : index +1 > maxValid
              })
            }
              onClick={(e) => {
                e.stopPropagation()
               if( index +1 > maxValid) return
                handleOnSelectQuantity(e, index + 1)
              }}
            >{index + 1}
            </li>)
          })}
        </ul>
      </div>}
    </button>
  )
}
